import { Icon3d3d, Icon3dAlert, Icon3dCycle, Icon3dDetect, Icon3dLocation, Icon3dMeter, IconMeter, IconWarning, IconZoneGray } from '@assets/images/icon';
import { accessAutoThumb, deadboltThumb, emlockThumb } from '@assets/images/main/access/product';
import {
  IconAoaOff,
  IconAoaOn,
  IconComfortInv,
  IconComfortOff,
  IconComfortOn,
  IconOsOff,
  IconOsOn,
  IconTwinTrackerAoaInv,
  IconTwinTrackerInv,
  IconTwintrackerOff,
  IconTwintrackerOn,
} from '@assets/images/main/icon';
import { IconBlueShield } from '@assets/images/main/icon/blue';
import {
  accessKey1,
  accessKey2,
  accessKey3,
  accessKey4,
  accessOutlook,
  IconBox,
  IconComputer,
  IconGuarantee,
  assetOn,
  workerOn,
  workerOff,
  IconPath,
  IconLocation,
  IconAnalyze,
  IconAlarm,
  IconExcel,
  IconSDK,
  assetOff,
  rtlsScreenshot1D,
  rtlsScreenshot1T,
  rtlsScreenshot1M,
  rtlsScreenshot2D,
  rtlsScreenshot2T,
  rtlsScreenshot2M,
  rtlsScreenshot3D,
  rtlsScreenshot3T,
  rtlsScreenshot3M,
  rtlsScreenshot4D,
  rtlsScreenshot4T,
  rtlsScreenshot4M,
  rtlsMainBanner,
  rtlsMainBannerProduct,
} from '@assets/images/main/index';
import {
  RtlsFunctions1D,
  RtlsFunctions1M,
  RtlsFunctions1T,
  RtlsFunctions2D,
  RtlsFunctions2M,
  RtlsFunctions2T,
  RtlsFunctions3D,
  RtlsFunctions3M,
  RtlsFunctions3T,
  RtlsFunctions4D,
  RtlsFunctions4M,
  RtlsFunctions4T,
  RtlsFunctions5D,
  RtlsFunctions5M,
  RtlsFunctions5T,
} from '@assets/images/main/rtls/main/functions';
import {
  RtlsHardware1D,
  RtlsHardware1M,
  RtlsHardware1T,
  RtlsHardware2D,
  RtlsHardware2M,
  RtlsHardware2T,
  RtlsHardware3D,
  RtlsHardware3M,
  RtlsHardware3T,
  RtlsHardware4D,
  RtlsHardware4M,
  RtlsHardware4T,
} from '@assets/images/main/rtls/main/hardware';
import { assetTag, twinTracker1, twinTrackerBracket } from '@assets/images/main/rtls/product';

export default {
  banner: {
    title: '실내 위치추적<br/>더 단순하게. 더 정확하게.',
    desc: '고정형부터 휴대형까지,<br/>공간 제약 없이 적용 가능한 고정밀 위치 추적 기술을 경험해보세요.',

    bgImg: rtlsMainBanner,
    productImg: rtlsMainBannerProduct,
    schemeTitle: '당신에게 맞는 위치추적을 선택하세요.',
    schemeDesc: '결정하는데 도움이 필요하신가요? ',
    schemeDesc2: '로 연락 주시면<br/>출입 전문가가 도와드리도록 하겠습니다.',
    phone: '1522-9928',

    card: [
      {
        title: '국내 유일',
        desc: '위치 추적 적용<br/>네트워크 단말기 제조',
      },
      {
        title: '500억 건 +',
        desc: '아시아 최대 규모의<br/>실시간 위치 정보 데이터',
      },
      {
        title: '세계 최고 성능',
        desc: 'AI 알고리즘을 이용한<br/>세게 최고 수준의 위치 정확도',
      },
    ],
  },

  mainPage: {
    product: {
      title: '제품 구성 알아보기',
      desc: '혁신적인 위치추적 제품 구성을 확인 해 보세요.',
      asset: {
        title: '블루투스(BLE) 위치추적',
        desc: 'BLE 태그 단말기를 자산 또는 추적하고자 하는 대상에 부착하여<br/>실시간 위치 추적 가능',
      },
      worker: {
        title: '고정밀(UWB) 위치추적',
        desc: 'UWB 태그 단말기를 자산 또는 추적하고자 하는 대상에 부착하여<br/>실시간 위치 및 동선 추적 가능',
      },
    },
  },

  screenShot: [
    {
      title: '현장 전체를 지도 위에 펼치다',
      desc: 'BLE/UWB/AoA 기반의 위치 정보가 실시간으로 건물 도면, 구역 지도에 표시됩니다.<br/>층별 보기, 구역 필터, 상태 아이콘으로 시각적 관리가 용이합니다.',
      img: {
        desktop: rtlsScreenshot1D,
        tablet: rtlsScreenshot1T,
        mobile: rtlsScreenshot1M,
      },
    },
    {
      title: '과거의 움직임도 현재처럼 되돌려 보기',
      desc: '인원 또는 자산의 이동 이력을 타임라인 기반으로 녹화/재생할 수 있습니다.<br/>특정 시간대를 선택하여 개별 또는 다수 대상의 동선을 동시에 비교하거나, 이상 상황을 되짚을 수 있습니다.',
      img: {
        desktop: rtlsScreenshot2D,
        tablet: rtlsScreenshot2T,
        mobile: rtlsScreenshot2M,
      },
    },
    {
      title: '가장 많이 움직인 구역이 한눈에',
      desc: '시간대별 이동량을 시각적으로 표현한 히트맵 기능을 제공합니다.<br/>작업자 밀집 구역, 비효율적인 동선, 방치된 공간 등을 분석해 레이아웃 개선이나 인원 배치 최적화에 활용할 수 있습니다',
      img: {
        desktop: rtlsScreenshot3D,
        tablet: rtlsScreenshot3T,
        mobile: rtlsScreenshot3M,
      },
    },
    {
      title: '지정된 Zone에 들어오면, 시스템이 즉시 반응합니다',
      desc: 'ORBRO OS에서는 원하는 영역(Zone)을 지도 위에 직접 정의할 수 있습니다.<br/>특정 인원 또는 자산이 해당 Zone에 진입하거나 이탈하면, 즉시 알림이 발생합니다.<br/>이 알림 이벤트는 API로도 제공되어, 외부 시스템과 유연하게 연동할 수 있습니다.',
      img: {
        desktop: rtlsScreenshot4D,
        tablet: rtlsScreenshot4T,
        mobile: rtlsScreenshot4M,
      },
    },
  ],

  video: {
    title: 'ORBRO 위치추적 시스템',
    desc: [
      { text: '대시보드 기능을 통하여 기기의 상태, 태그 단말기의 변동 추이 카테고리별 분류 현황, 구역별 현황들을<br/>한눈에 빠르게 확인할 수 있습니다.' },
      { text: '디바이스를 기준으로 대상의 위치와 현황을 빠르게 파악할 수 있습니다.<br/>정확한 데이터와 쉬운 인터페이스를 제공합니다.' },
      { text: '작업 공간부터 위험 구역까지 빠르게 설정할 수 있고<br/> 구역별 현황을 빠르게 파악할 수 있습니다.' },
      { text: '위험 구역에 진입하는 경우를 비롯하여,<br/>다양한 상황에 알맞은 알람을 빠르게 보낼 수 있습니다.' },
    ],
  },

  functions: {
    title: '위치추적의 시스템의<br/>혁신적인 경험',
    desc: '오브로의 위치 추적 시스템은 관리자 웹뿐만 아니라 모바일 앱까지 제공하여 사용자에게 최상의 경험을 제공하는 서비스입니다.<br/>이를 통해 현존하는 위치 추적 시스템 중 최고 수준의 사용자 편의성을 경험할 수 있습니다.',

    line: 2,
    card: [
      {
        size: '3',
        tag: '통합 관리 소프트웨어',
        title: '실내 지도 기반의<br/>소프트웨어 제공',
        label: '관리자',
        img: {
          desktop: RtlsFunctions1D,
          tablet: RtlsFunctions1T,
          mobile: RtlsFunctions1M,
        },
      },
      {
        size: '1',
        tag: '모바일 앱 제공',
        title: '모바일 앱을통한<br/>위치 추적 제공',
        label: '공통 제공',
        img: {
          desktop: RtlsFunctions2D,
          tablet: RtlsFunctions2T,
          mobile: RtlsFunctions2M,
        },
      },
      {
        size: '2',
        tag: '단말기 이력 관리',
        title: '구역별 위치 실시간 기록<br/>다운로드 제공',
        label: '관리자',
        img: {
          desktop: RtlsFunctions3D,
          tablet: RtlsFunctions3T,
          mobile: RtlsFunctions3M,
        },
      },
      {
        size: '2',
        tag: '구역 설정',
        title: '구역별 실시간<br/>기기 추적',
        label: '관리자',
        img: {
          desktop: RtlsFunctions4D,
          tablet: RtlsFunctions4T,
          mobile: RtlsFunctions4M,
        },
      },
      {
        size: '2',
        tag: '기기 관리',
        title: '편리한<br/>단말기 관리',
        label: '관리자',
        img: {
          desktop: RtlsFunctions5D,
          tablet: RtlsFunctions5T,
          mobile: RtlsFunctions5M,
        },
      },
    ],
  },

  hardware: {
    title: '핵심은 하드웨어,<br/>모든 것을 가볍게 혁신.',
    desc: '우리 위치 추적 시스템의 단말기는 특별 제작된 장치로, 지향성 안테나와 현장 환경을 고려한 디자인입니다.<br/>최적의 성능과 안정성을 위해 지향성 안테나를 적용하였으며, 다양한 상황에서도 효과적으로 동작합니다.',
    card: [
      {
        img: {
          desktop: RtlsHardware1D,
          tablet: RtlsHardware1T,
          mobile: RtlsHardware1M,
        },
        tag: '지향성 안테나',
        title: '지향성 안테나로<br/>정확한 위치 추적',
        desc: 'TwinTracker(위치추적단말기)의 지향성 안테나가<br/>무선신호의 방향을 유추 할 수 있도록 합니다.',
      },
      {
        img: {
          desktop: RtlsHardware2D,
          tablet: RtlsHardware2T,
          mobile: RtlsHardware2M,
        },
        tag: '다양한 브라켓',
        title: '천장 매립형,<br/>레일 등 설치 가능',
        falldown: [
          {
            title: '천장 매립형 브라켓',
            desc: '석고, 텍스, SMC, 마이톤 등<br/>다양한 천장 설치 가능.',
          },
          {
            title: '레일형 브라켓',
            desc: '조명에 사용하는 레일과 동일한 규격으로<br/>천장에 레일만 설치 되어있으면 언제든지 설치가 가능합니다.',
          },
        ],
      },
      {
        img: {
          desktop: RtlsHardware3D,
          tablet: RtlsHardware3T,
          mobile: RtlsHardware3M,
        },
        tag: '혁신적인 기술',
        title: 'TDoA기술을 이용한<br/>최소 설치, 최대 퍼포먼스',
        desc: 'TDoA기술은 고성능의 통신성능을 유지하면서도 배터리를 혁신적으로 감소시킨 통신기술입니다. <br/>실시간으로 동작 하면서도 위치 정밀도는 오히려 기존대비 훨씬 더 높은 수치를 기록합니다.',
      },
      {
        img: {
          desktop: RtlsHardware4D,
          tablet: RtlsHardware4T,
          mobile: RtlsHardware4M,
        },
        tag: '다양한 통신 방식',
        title: '유선통신, 무선 통신<br/>모두 연결 가능',
      },
    ],
  },

  faqRequest: '언제든지 문의',
  faqRequestTail: '주세요.',
  FAQ: [
    {
      title: '기술에 대한 전문 지식이 없습니다. 그래도 사용 가능할까요?',
      description:
        'ORBRO 시스템은 기술에 대한 지식이 전혀 없는 사람들도 사용할 수 있도록 간단하지만 강력한 인터페이스를 제공합니다. <br/>무엇보다 시각화된 데이터를 통해서 직관적인 분석과 사용이 가능하도록 시스템을 만들었습니다.',
    },
    {
      title: '위치 추적이 얼마나 정교한가요?',
      description:
        'ORBRO RTLS 시스템의 정확도는 굉장히 정교합니다.<br/>실시간 데이터를 반영하는 것이 중요한 만큼, 거의 오차가 없을 만큼 정확하고 빠른 데이터 연동이 가능합니다.',
    },
    {
      title: '이 제품들로 위치 추적만 가능한가요? 다른 기능도 추가하고 싶습니다.',
      description:
        'ORBRO의 기술은 많은 확장성을 가지고 있습니다.<br/>위치 추적뿐 아니라, 동선 파악, 경로 이탈, 접근 금지 구역 설정 등 다양한 활용기술을 적용할 수 있습니다.',
    },
    {
      title: 'ORBRO의 위치 추적 시스템은 어떻게 작동하나요?',
      description:
        'ORBRO는 BLE, UWB, AoA 같은 무선 전파 기술을 기반으로 Tag에서 송신된 신호를 Anchor가 수신하여 위치를 계산합니다.<br/>계산된 위치 정보는 ORBRO OS의 지도 화면에서 실시간으로 확인할 수 있으며, 모바일 앱에서도 동일하게 조회할 수 있습니다.',
    },
    {
      title: 'TwinTracker BLE, UWB, AoA는 어떻게 다른가요?',
      description:
        'BLE: 저전력, 설치 간편, 약 1~3m 정확도<br/>UWB: 고정밀(10~30cm), 빠른 응답, 복잡한 환경에 적합<br/>AoA: BLE 신호의 도달 각도 기반 위치 계산, 실내 정밀 동선 분석에 유리',
    },
    {
      title: 'Comfort Kit도 ORBRO 시스템과 연동되나요?',
      description:
        'Comfort Kit은 모바일 기반의 독립형 제품으로, ORBRO OS나 Server 없이도 사용할 수 있습니다.<br/>스마트폰 앱을 통해 실시간 위치를 확인할 수 있으며, 서버 설치가 어려운 환경에서도 간편하게 사용 가능합니다.',
    },
    {
      title: 'ORBRO OS는 어떤 환경에서 사용하나요?',
      description:
        'ORBRO OS는 ORBRO Server 또는 ORBRO Edge가 설치된 환경에서 사용되며,<br/>위치 추적, 이벤트 모니터링, 이력 분석 등을 제공합니다.<br/>지도 기반 UI로 시각화되며, 관리자와 운영자가 쉽게 활용할 수 있도록 설계되어 있습니다.',
    },
    {
      title: '계산된 위치 정보를 외부 시스템에서도 사용할 수 있나요?',
      description:
        '네, ORBRO는 위치 데이터를 외부 시스템과 연동할 수 있도록 API를 제공합니다.<br/>이를 통해 고객 시스템, 스마트팩토리 플랫폼, 보안관제 시스템 등과 통합해 다양한 활용이 가능합니다.',
    },
    {
      title: '한 현장에서 여러 제품을 동시에 사용할 수 있나요?',
      description:
        '가능합니다.<br/>BLE, UWB, AoA 기반의 제품을 혼합 구성하여 하나의 플랫폼에서 함께 운영할 수 있으며,<br/>복합 환경에 적합한 최적의 솔루션 구성이 가능합니다.',
    },
    {
      title: '실내외 모두 위치 추적이 가능한가요?',
      description: '실내에서는 BLE, UWB, AoA 기술이 사용되고,<br/>실외에서는 GPS 기반 추적과 연동하여 하이브리드 구성으로 운영할 수 있습니다.',
    },
    {
      title: 'Tag는 얼마나 많이 동시에 운영할 수 있나요?',
      description: '시스템 설계와 서버 사양에 따라 수십 개부터 수천 개까지 확장할 수 있으며,<br/>ORBRO는 대규모 환경에서도 안정적인 트래킹 성능을 제공합니다.',
    },
    {
      title: '설치나 유지관리는 어렵지 않나요?',
      description:
        'ORBRO는 설치 설계부터 시공, 시운전까지 전 과정을 지원합니다.<br/>대부분의 장치는 원격 상태 점검과 펌웨어 업데이트가 가능하며,<br/>유지관리는 간단한 배터리 교체와 주기적인 점검만으로 충분합니다.',
    },
    {
      title: '위치 정보는 어떤 방식으로 확인하나요?',
      description:
        '위치 정보는 ORBRO OS의 지도 화면에서 시각적으로 확인할 수 있으며,<br/>모바일 앱에서도 동일한 데이터를 실시간으로 볼 수 있습니다.<br/>또한 API를 통해 외부 시스템에서 활용할 수도 있어, 다양한 운영 환경에 유연하게 적용 가능합니다.',
    },
  ],

  bannerData: [
    {
      icon: IconTwintrackerOn,
      iconInv: IconTwinTrackerInv,
      iconOff: IconTwintrackerOff,
      image: '',
      iconText: 'TwinTracker UWB',
      sub: 'New',
      link: '/rtls/uwb',
    },
    {
      icon: IconAoaOn,
      iconInv: IconTwinTrackerAoaInv,
      iconOff: IconAoaOff,
      image: '',
      iconText: 'TwinTracker AoA',
      sub: 'New',
      link: '/rtls/aoa',
    },
    {
      icon: IconTwintrackerOn,
      iconInv: IconTwinTrackerInv,
      iconOff: IconTwintrackerOff,
      image: '',
      iconText: 'TwinTracker BLE',
      sub: 'New',
      link: '/rtls/ble',
    },
    {
      icon: IconComfortOn,
      iconInv: IconComfortInv,
      iconOff: IconComfortOff,
      image: '',
      iconText: 'Comfort Kit',
      sub: 'New',
      link: '/rtls/comfort',
    },
  ],

  product: {
    asset: {
      func: '배터리가 내장된 제품으로 전원 공사 필요없이 출입문 옆에 부착하여 쉽고 빠르게 모바일로 출입문 제어가 가능합니다.',
      key1: accessKey1,
      key2: accessKey2,
      key3: accessKey3,
      key4: accessKey4,
      outlook: accessOutlook,
    },
  },

  purchaseDesc: {
    asset: '자산 또는 추적하고자 하는 대상에 BLE 태그 단말기를 부착하여 위치를 추적할 수 있습니다.',
    worker: '자산 또는 추적하고자 하는 대상에 UWB 태그 단말기를 부착하여 위치를 추적할 수 있습니다.',
  },

  purchase: {
    //모바일
    asset: {
      assetTracking: {
        icon: accessKey1,
        title: '자산 위치추적',
        serial: 'Asset-Tracking',
        price: '5,900,000',

        note: [
          { text: 'TwinTracker (BLE) 10대', icon: IconBox },
          { text: '자산 추적 태그 30대', icon: IconBox },
          { text: 'Server PC 1대', icon: IconComputer },
          { text: '3년 간 보증기간', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'Asset Tag(BLE)',
            price: '30,000',
            img: assetTag,
          },
          {
            title: 'TwinTracker(BLE)',
            price: '300,000',
            img: twinTracker1,
          },
          {
            title: 'TwinTracker Bracket',
            price: '100,000',
            img: twinTrackerBracket,
          },
        ],
        mark: '',
      },
    },

    //자동문 출입
    worker: {
      workerTracking: {
        icon: accessKey1,
        title: '작업자 위치추적',
        serial: 'Worker-Tracking',
        price: '5,000,000',

        note: [
          { text: 'TwinTracker (UWB) 10대', icon: IconBox },
          { text: '작업자 추적 태그 10대', icon: IconBox },
          { text: 'Server PC 1대', icon: IconComputer },
          { text: '3년 간 보증기간', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'Tag(UWB)',
            price: '60,000',
            img: emlockThumb,
          },
          {
            title: 'TwinTracker(UWB)',
            price: '300,000',
            img: deadboltThumb,
          },
          {
            title: 'TwinTracker Bracket',
            price: '100,000',
            img: accessAutoThumb,
          },
        ],
        mark: '',
      },
    },
  },

  func: {
    title: '기능 더 알아보기',
    desc: '위치 추적의 다양한 기능을 확인해 보세요.',

    data: [
      {
        img: IconBlueShield,
        title: '권한 및 그룹 관리',
        desc: '관리자/사용자 권한을 구분하여 역할별 기능 접근을 제어할 수 있으며, 부서나 팀 단위로 그룹 구성이 가능합니다.',
      },
      {
        img: IconAlarm,
        title: '조건 알림 설정 (5단계)',
        desc: '지정된 조건에 따라 총 5단계의 알림 등급을 설정할 수 있어 이상 징후를 신속하게 감지하고 대응할 수 있습니다.',
      },
      {
        img: Icon3dMeter,
        title: '구역 모니터링 (Zone)',
        desc: '지도 위에 Zone을 설정하고 해당 구역에 진입한 인원이나 자산을 실시간으로 모니터링할 수 있습니다.',
      },
      {
        img: Icon3dCycle,
        title: '역주행 감지',
        desc: '이동 경로의 방향성과 반대되는 움직임을 시스템이 자동으로 감지하고 경고를 발생시킵니다.',
      },
      {
        img: Icon3dLocation,
        title: '카테고리 기반 추적 관리',
        desc: '태그 단말기를 인원, 자산, 차량 등으로 분류하여 효율적인 데이터 관리와 통계 분석이 가능합니다.',
      },
      {
        img: Icon3dAlert,
        title: '지속 미검출 태그 알림',
        desc: '일정 시간 동안 신호가 감지되지 않는 태그에 대해 관리자에게 자동 알림을 전송합니다.',
      },
      {
        img: Icon3dDetect,
        title: '입출입 감지 (In/Out Zone)',
        desc: '출입 구역에 대한 입장과 퇴장을 자동으로 감지하며, 출입 기록 및 체류 시간 분석도 지원합니다.',
      },
      {
        img: Icon3d3d,
        title: '기기 검색 및 상태 관리',
        desc: '다수의 Tag 및 Anchor 기기의 검색, 배터리 및 연결 상태를 한눈에 파악하고 관리할 수 있습니다.',
      },
    ],
  },
};
